import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `RegistroAlimentacion/generarExcel`, method: 'POST', body: values, token: token})
}